import React from "react";
import { Caption } from "src/atoms/typography";

export default function withStartTimeColumnWidth({ startTime, maxWidth }) {
  return function (Component) {
    return class extends React.Component {
      state = {
        startTimeColumnWidth: null
      };
      widestStartTimeElementRef = React.createRef();

      componentDidMount() {
        const widestStartTimeElement = this.widestStartTimeElementRef.current;
        this.setState({
          startTimeColumnWidth: Math.min(
            maxWidth,
            Math.ceil(widestStartTimeElement.getBoundingClientRect().width + 2)
          )
        });
      }

      render() {
        const { startTimeColumnWidth } = this.state;

        return startTimeColumnWidth ? (
          <Component
            {...this.props}
            startTimeColumnWidth={startTimeColumnWidth}
          />
        ) : (
          <Caption
            as="span"
            reference={this.widestStartTimeElementRef}
            position="absolute"
            transform="translateX(-1000px)"
            height="0px"
            visibility="hidden"
          >
            {startTime}
          </Caption>
        );
      }
    };
  };
}
